import React, { useEffect, useState,useLayoutEffect,useRef } from "react";
import { Eye, Edit3 } from "lucide-react";
import eyeIcon from '../assets/eye-icon.svg';
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { getUser } from "../auth";
import editIcon from "../assets/edit.svg";
import searchIcon from "../assets/search-icon.svg";
import { formatMoney } from "../utils/formatMoney";
import deleteIcon from "../assets/delete.svg";
import { FiSearch } from "react-icons/fi";
import CustomerEntitySelect from "../components/CustomerEntitySelect";
import Breadcrumb from "../components/Breadcrumbs";
import { useOverflowTooltip } from "../hooks/useOverflowTooltip";
import CustomTooltip from "../components/CustomTooltip";
import axios from "../axiosSetup";
import "./Quotes.css"
import "./Orders.css";
 
export default function Orders() {
  const [role, setRole] = useState("customer"); 
  const [customerFilter, setCustomerFilter] = useState("");
  const [orders, setOrders] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [orderNameList, setOrderNameList] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const [pageSize] = useState(10);
const [orderInput, setOrderInput] = useState("");   // typing only
const [orderFilter, setOrderFilter] = useState(""); // applied to API
const [pageCorrected, setPageCorrected] = useState(false);
const STATE_KEY = "ORDERS_STATE";
const [stateRestored, setStateRestored] = useState(false);
const [quoteNoInput, setQuoteNoInput] = useState("");
const [quoteNoFilter, setQuoteNoFilter] = useState("");

const [statusFilter, setStatusFilter] = useState("Draft");
const lastFetchKeyRef = React.useRef(null);
const allowPersistRef = useRef(false);
const [isPageLoading, setIsPageLoading] = useState(true);
  const navigate = useNavigate();

 useEffect(() => {
  const saved = sessionStorage.getItem(STATE_KEY);
  if (!saved) {
    setStateRestored(true);
    return;
  }

  const s = JSON.parse(saved);

  const restoredOrder = s.orderFilter ?? "";

  setOrderInput(s.orderInput ?? "");
  setOrderFilter(restoredOrder);
  setCustomerFilter(s.customerFilter !== undefined && s.customerFilter !== null
   ? String(s.customerFilter)
    : "");
  setCurrentPage(s.currentPage ?? 1);

  //  PRELOAD option BEFORE rendering CustomSelect
  if (restoredOrder) {
    setOrderNameList(prev => [
      { label: restoredOrder, value: restoredOrder },
      ...prev,
    ]);
  }
//  CHANGE 3 — ADD THIS BLOCK (RIGHT HERE)
  if (s.customerFilter) {
    setCustomerList(prev => {
      const val = String(s.customerFilter);
      if (prev.some(c => c.value === val)) return prev;

      return [
        {
          label: "Selected Customer",
          value: val,
          customerName: "Selected Customer",
          entityName: "-",
          searchText: "selected customer",
        },
        ...prev,
      ];
    });
  }
  setStateRestored(true);
}, []);


  useEffect(() => {
    const user = getUser();
    if (!user) return;
 
    setRole(user.userType === "customer" ? "customer" : "admin");
  }, []);
  const fetchCustomers = async () => {
  try {
   const res = await axios.get(
  "/order/dropdown/customers",
  {
    params: { status: "Draft" },   // 👈 pass query param
  }
);

    const list = res.data.map((c) => ({
      label: c.name,
      value: String(c.id),
      customerName: c.name || "-",
      entityName:
        c.entityName || c.entity || c.company || c.organization || c.businessName || "-",
      searchText: `${c.name || ""} ${
        c.entityName || c.entity || c.company || c.organization || c.businessName || ""
      }`,
    }));

    setCustomerList([
      {
        label: "All Customers",
        value: "",
        customerName: "All Customers",
        entityName: "-",
        searchText: "all customers",
      },
      ...list,
    ]);
  } catch (err) {
    console.error("❌ Failed to load customer names", err);
  }
};
useEffect(() => {
  if (!stateRestored) return;

  const toSave = {
    orderInput,
    orderFilter,
    customerFilter,
    currentPage,
  };

  sessionStorage.setItem(STATE_KEY, JSON.stringify(toSave));
}, [stateRestored, orderInput, orderFilter, customerFilter, currentPage]);


const customersFetchedRef = React.useRef(false);

useEffect(() => {
  if (role !== "admin") return; 

  if (customersFetchedRef.current) return;
  customersFetchedRef.current = true;

  fetchCustomers();
}, [role]);
const orderNamesFetchedRef = React.useRef(false);

useEffect(() => {
  if (!stateRestored) return;          // ⛔ wait
  if (orderNamesFetchedRef.current) return;

  orderNamesFetchedRef.current = true;

  const fetchOrderNames = async () => {
    try {
      const res = await axios.get(
        "/order/dropdown/purchaseOrderId"
      );

      const list = res.data.map((name) => ({
        label: name,
        value: name,
      }));

      setOrderNameList([{ label: "All", value: "" }, ...list]);
    } catch (err) {
      console.error("❌ Failed to load order names", err);
    }
  };

  fetchOrderNames();
}, [stateRestored]);

useLayoutEffect(() => {
  if (!orderFilter) return;

  setOrderNameList(prev => {
    if (prev.some(o => o.value === orderFilter)) return prev;

    return [
      { label: orderFilter, value: orderFilter },
      ...prev,
    ];
  });
}, [orderFilter]);


const handleDeleteOrder = async (orderId) => {
  if (!window.confirm("Are you sure you want to delete this order?")) return;

  try {
    await axios.delete(
      `/order/${orderId}`
    );

    setOrders((prev) => prev.filter((o) => o.id !== orderId));
  } catch (err) {
    console.error("Delete failed", err);
    alert("Failed to delete order");
  }
};

  const columns =
  role === "admin"
    ? [
        { key: "customerName", label: "Customer Name" },
        // { key: "id", label: "Order Id" },
        // { key: "name", label: "Order Name" },
        {key:"id", label:"Purchase Order No"},
        { key: "referenceId", label: "Sales Order No" },
        { key: "createdAt", label: "Requested Date" },
        { key: "total", label: "Total" },
        // { key: "status", label: "Status" }
      ]
    : [
        // { key: "id", label: "Order Id" },
        // { key: "name", label: "Order Name" },
        { key: "id", label: "Purchase Order No" },
        { key: "referenceId", label: "Sales Order No" },
        { key: "createdAt", label: "Requested Date" },
        { key: "total", label: "Total" },
        // { key: "status", label: "Status" }
      ];
const ORDER_STATUS_OPTIONS = [
  { label: "All Status", value: "" },
  { label: "Approved", value: "Approved" },
  { label: "Pending", value: "Pending" },
  { label: "Unapproved", value: "Unapproved" },
  { label: "Completed", value: "Completed" },
];

 
  const showFilters = role === "admin";
  const formatDate = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
};

const normalizeQuoteRow = (row) => {
  if (!row) return null;
  return {
    ...row,
    customerName: row.customerName || row.customer?.name || row.customer?.customerName || "-",
    referenceId: row.referenceOrderId ?? row.referenceId ?? "-",
  };
};

  const canEdit = role === "admin";
useEffect(() => {
  if (!stateRestored) return;
  const fetchKey = JSON.stringify({
  page: currentPage,
  customer: customerFilter || "",
  order: orderFilter || "",
  quoteNo: quoteNoFilter || "",
  status: statusFilter || "",
});

  // 🔐 Prevent duplicate StrictMode execution
  if (lastFetchKeyRef.current === fetchKey) {
    return;
  }

  lastFetchKeyRef.current = fetchKey;

  const fetchOrders = async () => {
    setIsPageLoading(true);
    try {
      const res = await axios.get(
        "/order",
        {
          params: {
            page: currentPage,
            customerId: customerFilter || undefined,
            purchaseOrderId: orderFilter || undefined,
            quoteNo: quoteNoFilter || undefined,
            status: statusFilter || undefined,
          },
        }
      );

      const rows = (res.data.orders || []).map(normalizeQuoteRow).filter(Boolean);
      setOrders(rows);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) {
      console.error("❌ Failed to fetch orders:", err);
    } finally {
      setIsPageLoading(false);
    }
  };

  fetchOrders();
}, [stateRestored,currentPage, customerFilter, orderFilter, quoteNoFilter, statusFilter]);

 const handlePageChange = (page) => setCurrentPage(page);

const renderPageNumbers = () => {
  const pages = [];

  pages.push(
    <button
      key={1}
      className={`ot-page-number ${currentPage === 1 ? "active" : ""}`}
      onClick={() => handlePageChange(1)}
    >
      1
    </button>
  );

  if (currentPage > 3) {
    pages.push(<span key="ellipsis1" className="ot-page-ellipsis">...</span>);
  }

  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(currentPage + 1, totalPages - 1);
    i++
  ) {
    pages.push(
      <button
        key={i}
        className={`ot-page-number ${currentPage === i ? "active" : ""}`}
        onClick={() => handlePageChange(i)}
      >
        {i}
      </button>
    );
  }

  if (currentPage < totalPages - 2) {
    pages.push(<span key="ellipsis2" className="ot-page-ellipsis">...</span>);
  }

  if (totalPages > 1) {
    pages.push(
      <button
        key={totalPages}
        className={`ot-page-number ${currentPage === totalPages ? "active" : ""}`}
        onClick={() => handlePageChange(totalPages)}
      >
        {totalPages}
      </button>
    );
  }

  return pages;
};
useEffect(() => {
  if (!stateRestored) return;

  const t = setTimeout(() => {
    const value = orderInput.trim();

    lastFetchKeyRef.current = null;  // 🔓 force new fetch
    setCurrentPage(1);
    setOrderFilter(value);           // "" is allowed
  }, 300);

  return () => clearTimeout(t);
}, [orderInput, stateRestored]);

useEffect(() => {
  return () => {
    // ❌ Clear state unless explicitly allowed
    if (!allowPersistRef.current) {
      sessionStorage.removeItem(STATE_KEY);
    }
  };
}, []);

const OverflowCell = ({ text }) => {
  const { ref, showTooltip } = useOverflowTooltip(text);

  return (
    <CustomTooltip
      message={text}
      placement="top"
      color="#4A1476"
      show={showTooltip}
    >
      <span ref={ref} className="ot-truncate">
        {text || "-"}
      </span>
    </CustomTooltip>
  );
};
useEffect(() => {
  if (!stateRestored) return;

  const t = setTimeout(() => {
    const v = quoteNoInput.trim();
    setCurrentPage(1);
    setQuoteNoFilter(v);
    lastFetchKeyRef.current = null;
  }, 300);

  return () => clearTimeout(t);
}, [quoteNoInput, stateRestored]);

const loadingIcon = <LoadingOutlined style={{ fontSize: 34, color: "#f50087" }} spin />;
if (isPageLoading && orders.length === 0) {
  return (
    <div
      className="orders-page"
      style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
        <Spin indicator={loadingIcon} />
        <span style={{ color: "#f50087", fontWeight: 600 }}>Loading</span>
      </div>
    </div>
  );
}


  return (
    <div className="orders-page">
  <div className="orders-header">
     {/* <div>
      <h2>Customer Orders</h2>
      <p>
        View and manage {" "}
        {role !== "customer" ? "Customer Orders" : "your Orders"}
      </p>
    </div>   */}
    <Breadcrumb/>
  </div>

  <div className="orders-table-wrapper">
    <div className="orderpo-title-row">
      {/* <div className="orders-maintitle">
        <h3 className="orders-title">{role !== "customer"
            ? "Orders"
            : "Order History"}</h3>
        <p className="orders-subtitle">
          {role !== "customer"
            ? "All customer Orders in one place"
            : "All your Orders in one place"}
        </p>
      </div> */}
          <div className="PO-filters">
  {/* ADMIN → Customer dropdown */}
  {role === "admin" && (
    <CustomerEntitySelect
      value={customerFilter}
      onChange={(v) => {
        setCurrentPage(1);
        setCustomerFilter(String(v));
      }}
      width="16em"
      placeholder="Customer Name"
      options={customerList.map((c) => ({
        value: c.value,
        customerName: c.customerName || c.label || "-",
        entityName: c.entityName || c.entity || c.company || c.organization || c.businessName || "-",
        searchText:
          c.searchText ||
          `${c.customerName || c.label || ""} ${
            c.entityName || c.entity || c.company || c.organization || c.businessName || ""
          }`,
      }))}
    />
  )}

  {/* CUSTOMER → Purchase Order search */}
  {role === "customer" && (
    <div className="orders-filter-item search">
      <div className="orders-search-box">
        <img
          src={searchIcon}
          alt="search"
          className="orders-search-icon-img"
        />
        <input
          type="text"
          placeholder="Search Purchase Order No"
          value={orderInput}
          onChange={(e) => setOrderInput(e.target.value)}
        />
      </div>
    </div>
  )}

  {/* BOTH → Status filter */}
  {/* <CustomSelect
    value={statusFilter}
    onChange={(v) => {
      setCurrentPage(1);
      setStatusFilter(v);
    }}
    placeholder="Status"
    options={ORDER_STATUS_OPTIONS}
    width="16em"
  /> */}
</div>


    {/* {!showFilters && (
  <div className="orders-filter-item search">
    <div className="orders-search-box">
      <img src={searchIcon} alt="search" className="orders-search-icon-img" />
      <input
        type="text"
        placeholder="Search PO No"
        value={quoteNoInput}
        onChange={(e) => setQuoteNoInput(e.target.value)}
      />
    </div>
  </div>
)} */}

{/* <button className="orders-new-btn" onClick={() => {
    allowPersistRef.current = true;   // ✅ allow persistence
    navigate("/orders/add-order");
  }}>
        {role !== "customer"
            ? "+ New Orders"
            : "Add Orders"}
      </button> */}
</div>
      <div className="orders-scroll-box">
    <table className="orders-table">
      <thead>
        <tr>
          {columns.map((c) => (
            <th key={c.key}>{c.label}</th>
          ))}
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
  {orders.length === 0 ? (
    <tr>
      <td colSpan={columns.length + 1}>
        <div className="orders-empty-state">
          <div className="orders-empty-icon">
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M3 7L5 3H19L21 7V20C21 21.1 20.1 22 19 22H5C3.9 22 3 21.1 3 20V7Z"
                stroke="#D6D6D6"
                strokeWidth="1.5"
              />
              <path
                d="M3 7H21"
                stroke="#D6D6D6"
                strokeWidth="1.5"
              />
            </svg>
          </div>
          <div className="orders-empty-text">No data</div>
        </div>
      </td>
    </tr>
  ) : (
    orders.map((row, i) => (
      <tr key={i}>
{columns.map((c) => {
  const rightAligned = ["id", "referenceId", "total"].includes(c.key);

  const tdClass = rightAligned ? "ot-td-right" : "ot-td-left";

  if (c.key === "createdAt") {
    return (
      <td key={c.key} className={tdClass}>
        {formatDate(row.createdAt)}
      </td>
    );
  }

  if (c.key === "total") {
    const currency = row.currency || "£";
    return (
      <td key={c.key} className={tdClass}>
        {formatMoney(row.total, currency)}
      </td>
    );
  }

  if (c.key === "customerName") {
    return (
      <td key={c.key} className={tdClass}>
        <OverflowCell text={row.customerName} />
      </td>
    );
  }

  return (
    <td key={c.key} className={tdClass}>
      {row[c.key]}
    </td>
  );
})}



        {/* ACTIONS */}
        <td className="quotes-actions">
          {/* 👁 VIEW */}
          <CustomTooltip
            message="View PO"
            placement="top"
            color="#4A1476"
          >
            <button
              className="orders-icon-btn"
              onClick={() => {
                allowPersistRef.current = true;
                navigate(`/quotes/view/${row.id}`);
              }}
            >
              <img src={eyeIcon} alt="view" />
            </button>
          </CustomTooltip>

          {/* ✏️ EDIT — admin + pending */}
          {role === "admin" &&
            row.status?.toLowerCase() === "pending" && (
              <CustomTooltip
                message="Edit Order"
                placement="top"
                color="#4A1476"
              >
                <button
                  className="orders-icon-btn"
                  onClick={() => {
                    allowPersistRef.current = true;
                    navigate(`/orders/edit/${row.id}`);
                  }}
                >
                  <img
                    src={editIcon}
                    alt="edit"
                    style={{ width: 28, height: 26 }}
                  />
                </button>
              </CustomTooltip>
            )}

          {/* 🗑 DELETE — customer + pending */}
          {role === "customer" &&
            row.status?.toLowerCase() === "pending" && (
              <CustomTooltip
                message="Delete Order"
                placement="top"
                color="#4A1476"
              >
                <button
                  className="orders-icon-btn"
                  onClick={() => handleDeleteOrder(row.id)}
                  style={{ marginLeft: "4px" }}
                >
                  <img src={deleteIcon} alt="delete" />
                </button>
              </CustomTooltip>
            )}
        </td>
      </tr>
    ))
  )}
</tbody>

    </table>
    </div>
    <div className="ot-pagination-frame">
  <div className="ot-pagination-info">
    Page {currentPage} of {totalPages}
  </div>

  <div className="ot-pagination-controls">
    
    {/* Prev */}
    <button
      className="ot-pagination-arrow"
      disabled={currentPage === 1}
      onClick={() => handlePageChange(currentPage - 1)}
    >
      ‹
    </button>

    {/* Page Numbers */}
    <div className="ot-pagination-numbers">
      {renderPageNumbers()}
    </div>

    {/* Next */}
    <button
      className="ot-pagination-arrow"
      disabled={currentPage === totalPages}
      onClick={() => handlePageChange(currentPage + 1)}
    >
      ›
    </button>
  </div>
</div>
  </div>
</div>

  );
}
 
 
